module.exports = __webpack_public_path__ + "img/telephone_2.1c954963.svg";